import React from 'react';
import { Calendar } from '@/components/ui/calendar';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface DateRange {
  from: Date | undefined;
  to: Date | undefined;
}

interface SimpleDateSelectionProps {
  dateRange: DateRange;
  flexibility: string;
  onDateSelect: (range: any) => void;
  onFlexibilityChange: (flexibility: string) => void;
}

export function SimpleDateSelection({ 
  dateRange, 
  flexibility, 
  onDateSelect, 
  onFlexibilityChange 
}: SimpleDateSelectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>1. Select Your Dates</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="bg-white p-4 border rounded-lg">
          <Calendar
            mode="range"
            selected={dateRange}
            onSelect={onDateSelect}
            className="mx-auto"
            numberOfMonths={1}
          />
        </div>

        {dateRange.from && dateRange.to && (
          <div className="p-3 bg-blue-50 rounded-lg">
            <p className="text-sm font-medium text-blue-900">
              Selected: {dateRange.from.toLocaleDateString()} - {dateRange.to.toLocaleDateString()}
            </p>
          </div>
        )}

        <div className="space-y-2">
          <Label htmlFor="flexibility">Date Flexibility</Label>
          <Select value={flexibility} onValueChange={onFlexibilityChange}>
            <SelectTrigger id="flexibility">
              <SelectValue placeholder="Select flexibility" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="exact">Exact dates only</SelectItem>
              <SelectItem value="flexible_1_week">Flexible within 1 week</SelectItem>
              <SelectItem value="flexible_2_weeks">Flexible within 2 weeks</SelectItem>
              <SelectItem value="flexible_1_month">Flexible within 1 month</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
